import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import SecureLS from "secure-ls";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { useUser } from "../../Components/provider/user-id-provider";

function Admin() {
  const [clientId, setClientId] = useState("");
  const ls = new SecureLS();
  const navigate = useNavigate();
  const { setUserId } = useUser();

  const fetchId = () => {
    axios
      .get(`get_client_and_secret`)
      .then((res) => {
        setClientId(res.data.client_id);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchId();
  }, []);

  const handleLogin = (response: any) => {
    axios
      .post(`users/google_sign_in`, {
        token: response.credential,
        client_id: clientId,
      })
      .then((res) => {
        if (res.status === 200) {
          ls.set("isAuthenticated", true);
          ls.set("role", res?.data?.user?.role);
          ls.set("access_token", res?.data?.user?.access_token);
          setUserId(res?.data?.user?.id);
          navigate("/admin/our-work");
          toast.success("Logged In!!");
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(err.response.data.message || err.message);
      });
  };

  return (
    <GoogleOAuthProvider clientId="673635907738-bttm97du8abepgrh80cil8juibnftpp2.apps.googleusercontent.com">
      <div className="h-screen flex flex-col md:flex-row bg-white overflow-hidden relative">
        <motion.div
          className="w-full h-full relative"
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, ease: [0.25, 0.25, 0, 1] }}
        >
          <img
            src="https://images.unsplash.com/photo-1554110397-9bac083977c6?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fHx8fA%3D%3D"
            loading="lazy"
            alt="banner"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-br from-black/20 via-transparent to-black/40">
            <div className="absolute bottom-8 left-8">
              <h2 className="text-white text-4xl md:text-5xl font-light tracking-tight leading-tight">
                Softcoding
                <br />
                Solutions
              </h2>
            </div>
          </div>
        </motion.div>

        <motion.div
          className="md:w-2/5 flex items-center justify-center p-6 md:p-12 bg-white/10 backdrop-blur-xl h-full bottom-0 right-0 md:fixed"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2, ease: [0.25, 0.25, 0, 1] }}
        >
          <div className="w-full max-w-sm space-y-8">
            <div className="text-center space-y-2">
              <h1 className="text-3xl font-semibold md:text-white tracking-tight">
                Welcome back
              </h1>
              <p className="md:text-white text-sm">
                Sign in to access your dashboard
              </p>
            </div>

            <div className="flex justify-center">
              <GoogleLogin
                onSuccess={handleLogin}
                useOneTap
                theme="outline"
                size="large"
                width="280"
              />
            </div>
          </div>
        </motion.div>
      </div>
    </GoogleOAuthProvider>
  );
}

export default Admin;
